import {ActionType} from '../infrastructure/actionTypes';
import {ICreateProductState} from '../infrastructure/interfaces';

const productStateGlobal: ICreateProductState = {
    templateType: 'Brochure',
    documentType: 'Catalog',
};

export default (state = productStateGlobal, action: any) => {
    switch (action.type) {
        case ActionType.SET_NEW_PRODUCT_PRODUCT_TYPE:
            productStateGlobal.documentType = action.prodType;
            return productStateGlobal;
        case ActionType.SET_NEW_PRODUCT_TEMPLATE_TYPE:
            productStateGlobal.templateType = action.templateType;
            return productStateGlobal;
        default:
            return state;

    }
};


// WEBPACK FOOTER //
// ./src/reducers/createProductState.ts